import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {InsoleDataSummaryModel} from "./insoleDataSummary.model";
import {LovValueSummaryConverter} from "../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {PermissionsConverter} from "../../../../../common/converter/permissions.converter";
import {
    InsolesProviderModelGabaritConverter
} from "../../../../provider/model/api/entity/insolesProviderModelGabarit.converter";
@Injectable({
    providedIn: 'root'
})
export class InsoleDataSummaryConverter extends HttpModelConverter<InsoleDataSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter,
                private gabaritConverter: InsolesProviderModelGabaritConverter) {
        super();
    }

    protected createInstance(): InsoleDataSummaryModel {
        return new InsoleDataSummaryModel();
    }

    protected enrichObject(result: InsoleDataSummaryModel, src: InsoleDataSummaryModel) {
        result.gabarit = this.lovValueSummaryConverter.convert(src.gabarit);
        result.providerInsoleModelGabarit = this.gabaritConverter.convert(src.providerInsoleModelGabarit);
        result.borderExternalLength = this.lovValueSummaryConverter.convert(src.borderExternalLength);
        result.shoeSize = this.lovValueSummaryConverter.convert(src.shoeSize);
        result.bevel = this.lovValueSummaryConverter.convert(src.bevel);
        result.border = this.lovValueSummaryConverter.convert(src.border);
        result.permissions = this.permissionConverter.convert(src.permissions);
        result.side = this.lovValueSummaryConverter.convert(src.side);
        result.thermo = this.lovValueSummaryConverter.convert(src.thermo);
        result.medioSmooth = this.lovValueSummaryConverter.convert(src.medioSmooth);
    }

}
